<template>
  <div>
    <select v-if="selected_task && !isDefaultProjectPriority" :ref="'prioritySelect'+unique_id" :id="'prioritySelect'+unique_id" v-model="selected_task.priority"  class="form-control form-control-sm mb-2" data-toggle="select">
      <option  :selected="selected_task.priority === option.id" v-for="option in options" :data-position="option.badge"
               :value="option.id" >
        {{option.name}}
      </option>
    </select>
    <select v-if="isDefaultProjectPriority" :ref="'prioritySelect'+unique_id" :id="'prioritySelect'+unique_id" v-model="project.default_priority"  class="form-control form-control-sm mb-2" data-toggle="select">
      <option  :selected="project.default_priority === option.id" v-for="option in options" :data-position="option.badge"
               :value="option.id" >
        {{option.name}}
      </option>
    </select>
  </div>

<!--    <div @mouseover="show=true" @mouseleave="show=false" class="btn-group-toggle mt-1" data-toggle="buttons">-->
<!--      <label v-on:click="setPriority('low')" :class="{'active': task.priority === 'low', 'show': show, 'hide': !show && task.priority !== 'low'}" class="btn btn-xs btn-white mt-2">-->
<!--        <input type="radio" name="options" id="priorityLow" checked=""> Low <span class="badge mt-1 badge-light">!</span>-->
<!--      </label>-->
<!--      <label v-on:click="setPriority('normal')" :class="{'active': task.priority === 'normal', 'show': show, 'hide': !show && task.priority !== 'normal'}" class="btn btn-xs btn-white mt-2">-->
<!--        <input type="radio" name="options" id="priorityNormal" checked=""> Normal <span class="badge mt-1 badge-soft-primary">!</span>-->
<!--      </label>-->
<!--      <label v-on:click="setPriority('high')" :class="{'active': task.priority === 'high', 'show': show, 'hide': !show && task.priority !== 'high'}" class="btn btn-xs btn-white mt-2">-->
<!--        <input type="radio" name="options" id="priorityHigh" checked=""> High <span class="badge mt-1 badge-soft-warning">!!</span>-->
<!--      </label>-->
<!--      <label v-on:click="setPriority('urgent')" :class="{'active': task.priority === 'urgent', 'show': show, 'hide': !show && task.priority !== 'urgent'}" class="btn btn-xs btn-white mt-2">-->
<!--        <input type="radio" name="options" id="priorityUrgent" checked=""> Urgent <span class="badge mt-1 badge-soft-danger">!!!</span>-->
<!--      </label>-->
<!--    </div>-->

</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        name: "PrioritySelect",
        computed: {
            ...mapGetters([
                'selected_task',
                'account',
                'projects',
                'selected_project_id',
            ])
        },
        data() {
            return {
                unique_id: 'no',
                show: false,
                options: [
                    {
                        name: 'Low',
                        id: 'low',
                        badge: '<span class="badge text-secondary badge-light">!</span>'
                    },
                    {
                        name: 'Normal',
                        id: 'normal',
                        badge: '<span class="badge badge-soft-primary">!</span>'
                    },
                    {
                        name: 'High',
                        id: 'high',
                        badge: '<span class="badge badge-soft-warning">!!</span>'
                    },
                    {
                        name: 'Urgent',
                        id: 'urgent',
                        badge: '<span class="badge badge-soft-danger">!!!</span>'
                    },
                ]
            }
        },
        props: {
          isDefaultProjectPriority: {
            default: false
          },
          project: {
            default: function () {
              return {}
            }
          }
        },
        watch: {
            selected_task: function () {
                this.enableSelect();
            },
            selected_project_id: function () {
              this.enableSelect();
            },
        },
        methods: {
            setPriority(new_priority) {
                this.selected_task = new_priority;
            },
            enableSelect() {
                let self = this;
                function init_select($this) {
                    let options = {
                        dropdownParent: $this.closest('.modal').length ? $this.closest('.modal') : $(document.body),
                        minimumResultsForSearch: -1,
                        templateResult: templateResult,
                        templateSelection: templateResult
                    };
                    $this
                        .select2(options)
                        .on('change', function () {
                            self.isDefaultProjectPriority ? self.$emit('newPriority', this.value) : self.selected_task.priority = this.value;
                            // self.$store.commit('setSelectedProjectId',  this.value);
                        });
                }

                function templateResult(avatar) {
                    if ( !avatar.id ) {
                        return avatar.text;
                    }
                    let $option = $(avatar.element);
                    let optionAvatar = $option.data('avatar-src');
                    let optionPosition = $option.data('position');
                    let output = '';
                    if ( optionAvatar ) {
                        output = $('<span class="avatar avatar-xs mr-3"><img class="avatar-img rounded-circle" src="' + optionAvatar + '" alt="..."></span>');
                    }
                    output += '<span>' + avatar.text + '</span>';
                    if (optionPosition) {
                        if (optionPosition === 'low') {
                            optionPosition = '123'
                        }
                        output += '<span class=" float-right">'+optionPosition +'</span>';
                    }
                    return $(output);
                }
                setTimeout(() => init_select( $(document.getElementById('prioritySelect'+self.unique_id))), 100);
            }
        },
        mounted() {
            this.unique_id = Math.random().toString();
            this.enableSelect();

        },
    }
</script>

<style scoped>

  .show {
    opacity: 1;
    -webkit-transition: opacity 0.3s ease-in-out;
    -moz-transition: opacity 0.3s ease-in-out;
    -ms-transition: opacity 0.3s ease-in-out;
    -o-transition: opacity 0.3s ease-in-out;
    transition: opacity 0.3s ease-in-out;
  }

  .hide {
    opacity: 0.4;
    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -ms-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
    transition: opacity 1s ease-in-out;
  }

  input{
    display: none;
  }

</style>
